import PropTypes from 'prop-types';

export const LocationInfoDetailRowPropType = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
});
